import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../../Components/Footer/Footer";

const RefundCancellationPolicy = () => {
	return (
		<><Header />

			<div className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
				{/* Container */}
				<div className="mx-auto max-w-5xl bg-white rounded-2xl shadow-md p-6 sm:p-10">

					{/* Title */}
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
						Refund and Cancellation Policy
					</h1>

					{/* Breadcrumb */}
					<p className="text-sm text-gray-500 mb-8">
						<Link to="/" className="hover:text-blue-600 transition-colors">
							Home
						</Link>
						<span className="mx-1">/</span>
						<span className="text-gray-700">
							Refund and Cancellation Policy
						</span>
					</p>

					{/* Content */}
					<div className="space-y-6 text-gray-700 text-sm sm:text-base leading-relaxed">

						<p>
							This refund and cancellation policy outlines how you can cancel or
							seek a refund for a product or service purchased through the
							platform.
						</p>

						<p>
							Cancellation requests will be considered only if the request is made
							within <span className="font-semibold">7 days</span> of placing the
							order. However, cancellation may not be entertained if the order has
							already been communicated to the seller or merchant and the shipping
							process has been initiated or the product is out for delivery. In
							such cases, you may choose to reject the product at the doorstep.
						</p>

						<p>
							<span className="font-semibold">
								DIGITAL NIGHT OWL PRIVATE LIMITED
							</span>{" "}
							does not accept cancellation requests for perishable items such as
							flowers, eatables, or similar products. Refund or replacement may be
							considered only if the quality of the delivered product is found to
							be unsatisfactory.
						</p>

						<p>
							In case of damaged or defective items, please report the issue to our
							customer service team within{" "}
							<span className="font-semibold">7 days</span> of receiving the
							product. The request will be reviewed after verification by the
							respective seller or merchant.
						</p>

						<p>
							If you believe that the product received is not as described on the
							website or does not meet your expectations, you must inform our
							customer service team within{" "}
							<span className="font-semibold">7 days</span> of delivery. After
							reviewing your complaint, an appropriate decision will be taken.
						</p>

						<p>
							For products that come with a manufacturer’s warranty, any
							complaints or issues should be directed to the respective
							manufacturer.
						</p>

						<p>
							In case any refund is approved by{" "}
							<span className="font-semibold">
								DIGITAL NIGHT OWL PRIVATE LIMITED
							</span>
							, the refund will be processed within{" "}
							<span className="font-semibold">3 days</span>.
						</p>

					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default RefundCancellationPolicy;
